<template>
    <div>
        <v-data-table
                :loading="loading"
                :headers="headers"
                :items="items"
                hide-default-footer
        >

            <template v-slot:top>
                <v-toolbar
                        flat
                >


                    <v-spacer></v-spacer>
                    <v-dialog
                            v-model="dialog"
                            max-width="500px"
                    >

                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    color="info"
                                    dark
                                    class="mb-2"
                                    v-bind="attrs"
                                    v-on="on"

                            >
                               <v-icon left small>fas fa-plus</v-icon> New Item
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <SessionSearch
                                                    future
                                                    :session="selectedSession"
                                                    @selected="onSessionSelected"
                                            />
                                            <v-text-field
                                                    v-model="editedItem.description"
                                                    label="Description"
                                            />
                                            <DatePicker
                                                    v-model="editedItem.deliveryDate"
                                                    label="Delivery Date"
                                            />
                                            <VFormBase :model="editedItem" :schema="schemaItem" :cols="12"/>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="close"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="save"
                                >
                                    Save
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                            <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>


            <template v-slot:item.deliveryDate="{ item }">
                {{ item.deliveryDate | formatDate}}
            </template>
            <template v-slot:item.price="{ item }">
                {{ item.price | toCurrency}}
            </template>
            <template v-slot:item.total="{ item }">
                {{ item.total | toCurrency}}
            </template>
            <template v-slot:item.description="{ item }">
                <router-link v-if="item.session"
                             :to="{name: 'training-class', params:{id:item.session.trainingClass.id}}">
                    {{ item.description }}
                </router-link>
                <template v-else>
                    {{ item.description }}
                </template>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon
                        v-if="!readonly"
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        v-if="readonly"
                        small
                        @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:item.vatPayable="{ item }">
                <v-checkbox
                        v-model="item.vatPayable"
                        color="success"
                        hide-details
                        class="shrink mr-2 mt-0 pa-0"
                        disabled
                        dense
                ></v-checkbox>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import VFormBase from 'vuetify-form-base';
    import SessionSearch from "../AutoCompletes/SessionSearch";
    import PO_DETAIL_CREATE from "../../graphql/PurchaseOrder/DetailCreate.gql";
    import PO_DETAIL_DELETE from "../../graphql/PurchaseOrder/DetailDelete.gql";
    import PO_DETAIL_UPDATE from "../../graphql/PurchaseOrder/DetailUpdate.gql";
    import DatePicker from "../DatePicker";

    export default {
        components: {
            VFormBase, SessionSearch, DatePicker
        },
        props: {
            purchaseOrder: {
                type: Object
            },
            items: {
                type: Array
            },
            loading: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dialog: false,
                dialogDelete: false,
                search: '',
                sortBy: ['date'],
                sortDesc: [true],
                editedIndex: -1,
                selectedSession: {},
                editedItem: {
                    purchaseOrder: {},
                    itemNumber: '',
                    deliveryDate: null,
                    description: '',
                    venue: '',
                    trainer: '',
                    quantity: 1,
                    price: 0,
                    total: 0,
                    vatPayable: 0,
                    session: {id: null},
                },
                defaultItem: {
                    purchaseOrder: {},
                    itemNumber: '',
                    deliveryDate: null,
                    description: '',
                    venue: '',
                    trainer: '',
                    quantity: 1,
                    price: 0,
                    total: 0,
                    vatPayable: 0,
                    session: {id: null},
                },
                headers: [
                    {
                        text: 'Item',
                        align: 'start',
                        value: 'itemNumber',
                    },
                    {
                        text: 'Delivery',
                        align: 'start',
                        value: 'deliveryDate',
                    },
                    {
                        text: 'Description',
                        align: 'start',
                        value: 'description',
                    },
                    {
                        text: 'Venue',
                        align: 'start',
                        value: 'venue',
                    },
                    {
                        text: 'Trainer',
                        align: 'start',
                        value: 'trainer',
                    },
                    {
                        text: 'Quantity',
                        align: 'start',
                        value: 'quantity',
                    },
                    {
                        text: 'Price',
                        align: 'start',
                        value: 'price',
                    },
                    {
                        text: 'Total',
                        align: 'start',
                        value: 'total',
                    },
                    {
                        text: 'VAT',
                        align: 'start',
                        value: 'vatPayable',
                    },
                    { text: 'Actions', value: 'actions', sortable: false },
                ],
            }
        },
        watch: {
            'editedItem.price': function () {
                this.updateTotalPrice()
            },
            'editedItem.quantity': function () {
                this.updateTotalPrice()
            }   ,
            'editedItem.session': function () {
                this.editedItem.description
            }
        },
        computed: {
            editedItemTotal() {
               return this.editedItem.quantity * this.editedItem.price
            },
            formTitle () {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
            schemaItem() {
                return {
                    venue: {type: 'text', label: 'Venue' , col: {cols: 12}},
                    trainer: {type: 'text', label: 'Trainer', col: {cols: 12}},
                    quantity: {type: 'number', label: 'Quantity', min: 1, step: '1', col: {cols: 4}},
                    price: {type: 'number', label: 'Price', min: 0, step: '0.01', prefix: "£", col: {cols: 4}},
                    total: {type: 'number', label: 'Total', prefix: "£", readonly: true, col: {cols: 4}},
                    vatPayable: {type: 'checkbox', label: 'VAT Payable', col: {cols: 12}},
                }
            },
        },
        methods: {
      //      ...mapActions('errors', ['setErrors']),
            onSessionSelected(session) {
                this.selectedSession = session
                this.editedItem.session = {connect: session.id}
                if(this.editedItem.description === '') {
                    if(session.trainingClass){
                        this.editedItem.description = session.trainingClass.title
                        this.editedItem.venue = session.trainingClass.location
                        this.editedItem.deliveryDate = session.date
                        this.editedItem.trainer = session.trainer.firstName + ' ' + session.trainer.lastName
                    }
                }
            },
            updateTotalPrice() {
                this.editedItem.total = parseFloat(this.editedItem.quantity * this.editedItem.price).toFixed(2)
            },
            editItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.selectedSession = item.session
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.saveDeleteItem(this.items[this.editedIndex])
                this.items.splice(this.editedIndex, 1)
                this.closeDelete()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
                this.editedItem.itemNumber = parseInt(this.items[this.items.length - 1].itemNumber) + 1
                this.editedItem.purchaseOrder = {connect: this.purchaseOrder.id}

                if (this.editedIndex > -1) {
                    Object.assign(this.items[this.editedIndex], this.editedItem)
                    this.saveUpdateItem(this.editedItem)
                } else {
                    this.createNewItem(this.editedItem)
                }
                this.close()
            },

            pushErrors(errors) {
                this.$emit('errors', errors)
            },

            createNewItem(item){
                this.$apollo.mutate({
                    mutation: PO_DETAIL_CREATE,
                    variables: {input: item},
                }).then((item) => {
                    this.items.push(item.data.createPurchaseOrderDetail)
                    this.$store.dispatch('notification/addSuccess', 'Save successful')
                    this.$emit('complete')
                }).catch((error) => {
                    this.updating = false
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            },

            saveDeleteItem(item) {
                this.$apollo.mutate({
                    mutation: PO_DETAIL_DELETE,
                    variables: {id: item.id},
                }).then(() => {
                    this.$emit('complete')
                    this.$store.dispatch('notification/addSuccess', 'Delete successful')
                }).catch((error) => {
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            },

            saveUpdateItem(item) {
                delete item.__typename
                if(item.session && item.session.__typename){
                    item.session = {connect: item.session.id}
                }
                this.$apollo.mutate({
                    mutation: PO_DETAIL_UPDATE,
                    variables: {input: item},
                }).then(() => {
                    this.$emit('complete')
                    this.$emit('saved')
                    this.$store.dispatch('notification/addSuccess', 'Save successful')
                }).catch((error) => {
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            }
        },
    }
</script>

